import { render, staticRenderFns } from "./IconSunRise.vue?vue&type=template&id=7c44033d&"
import script from "./IconSunRise.vue?vue&type=script&lang=js&"
export * from "./IconSunRise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports